import { render, staticRenderFns } from "./FipeAnoFabricacaoSelect.vue?vue&type=template&id=04adffc0"
import script from "./FipeAnoFabricacaoSelect.vue?vue&type=script&lang=js"
export * from "./FipeAnoFabricacaoSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports